/**
 * Filen inneholder konstanter fra visningsdefinisjon for næring som benyttes i SME og evt. andre applikasjoner
 * */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    KORTGRUPPER: function() {
        return KORTGRUPPER;
    },
    KORT: function() {
        return KORT;
    },
    LISTER: function() {
        return LISTER;
    },
    DYNAMISK_GRUPPE: function() {
        return DYNAMISK_GRUPPE;
    },
    FELLES_FELT: function() {
        return FELLES_FELT;
    },
    FELLES_FELT_DRIFTSMIDLER: function() {
        return FELLES_FELT_DRIFTSMIDLER;
    },
    FELT: function() {
        return FELT;
    },
    default: function() {
        return _default;
    }
});
var KORTGRUPPER = {
    OMLOEPSMIDLER_ID: "eiendelerEgenkapitalOgGjeld.kortsiktigeEiendeler.kortgruppe",
    SALGSINNTEKTER_ID: "inntekter.salgsinntekt.kortgruppe",
    SALGS_OG_REPRESENTASJONSKOSTNADER_ID: "kostnader.salgsrepresentasjon.kortgruppe",
    DRIFTS_OG_PRODKOSTNADER_ID: "kostnader.driftsOgProduksjonskostnader.kortgruppe",
    VERKTOEY_OG_INVENTAR_ID: "kostnader.verktoeyOgInventar.kortgruppe",
    VARELAGER_ID: "varelagerOgFordringer.varelager.kortgruppe",
    VAREKOSTNADER_ID: "kostnader.varekostnad.kortgruppe",
    FORDRINGER_KUNDEFORDRINGER_ID: "varelagerOgFordringer.fordringerKundefordringer.kortgruppe",
    BIOLOGISK_EIENDEL_ID: "varelagerOgFordringer.biologiskEiendel.kortgruppe",
    NAERINGSKJOERETOEY_ID: "driftsmidler.naeringskjoeretoey.kortgruppe",
    SALDOAVSKRIVING_ID: "driftsmidler.saldoavskriving.kortgruppe",
    LINEAER_AVSKRIVING_ID: "driftsmidler.lineaerAvskriving.kortgruppe",
    IKKE_AVSKRIVBARE_ANLEGGSMIDLER_ID: "driftsmidler.ikkeAvskrivbareAnleggsmidler.kortgruppe",
    GEVINST_OG_TAPSKONTO_ID: "driftsmidler.gevinstOgTapskonto.kortgruppe",
    LOENNSKOSTNADER_ID: "kostnader.loennskostnad.kortgruppe",
    ANDRE_DRIFTSKOSTNADER_ID: "kostnader.andreDriftskostnader.kortgruppe",
    BEREGNET_PERSONINNTEKT: "beregnetPersoninntekt.fordeltBeregnetPersoninntekt.kortgruppe",
    BEREGNET_NAERINGSINNTEKT: "beregnetNaeringsinntekt.fordeltBeregnetNaeringsinntekt.kortgruppe"
};
var KORT = {
    BALANSEVERDI_FOR_OMLOEPSMIDDEL_REF: "balanseverdiForOmloepsmiddel",
    BALANSEVERDI_FOR_ANLEGGSMIDDEL_REF: "balanseverdiForAnleggsmiddel",
    LANGSIKTIG_GJELD_REF: "langsiktigGjeld",
    KORTSIKTIG_GJELD_REF: "kortsiktigGjeld",
    EGENKAPITAL_REF: "egenkapital",
    SALGSINNTEKT_REF: "salgsinntekt",
    FINANSINNTEKT_REF: "finansinntekt",
    ANNEN_DRIFTSINNTEKT_REF: "annenDriftsinntekt",
    VAREKOSTNAD_REF: "varekostnad",
    LOENNSKOSTNAD_REF: "loennskostnad",
    FINANSKOSTNAD_REF: "finanskostnad",
    ANNEN_DRIFTSKOSTNAD_REF: "annenDriftskostnad",
    SALDOAVSKREVET_ANLEGGSMIDDEL_REF: "saldoavskrevetAnleggsmiddel",
    LINEAERT_AVSKREVET_ANLEGGSMIDDEL_REF: "lineaertavskrevetAnleggsmiddel",
    IKKE_AVSKRIVBARE_ANLEGGSMIDLER_REF: "ikkeAvskrivbartAnleggsmiddel",
    GEVINST_OG_TAPSKONTO_REF: "gevinstOgTapskonto",
    TOEMMERKONTO_REF: "skogOgToemmerkonto"
};
var LISTER = {
    RESULTAT: [
        KORT.SALGSINNTEKT_REF,
        KORT.FINANSINNTEKT_REF,
        KORT.ANNEN_DRIFTSINNTEKT_REF,
        KORT.VAREKOSTNAD_REF,
        KORT.LOENNSKOSTNAD_REF,
        KORT.FINANSKOSTNAD_REF,
        KORT.ANNEN_DRIFTSKOSTNAD_REF
    ],
    BALANSE: [
        KORT.BALANSEVERDI_FOR_ANLEGGSMIDDEL_REF,
        KORT.BALANSEVERDI_FOR_OMLOEPSMIDDEL_REF,
        KORT.LANGSIKTIG_GJELD_REF,
        KORT.KORTSIKTIG_GJELD_REF,
        KORT.EGENKAPITAL_REF
    ]
};
var DYNAMISK_GRUPPE = {
    INNTEKT_REF: "inntekt",
    KOSTNAD_REF: "kostnad",
    BALANSEVERDI_REF: "balanseverdi",
    KAPITAL_REF: "kapital",
    GJELD_REF: "gjeld"
};
var FELLES_FELT = {
    INNGAAENDE_VERDI: "inngaaendeVerdi",
    UTGAAENDE_VERDI: "utgaaendeVerdi"
};
var FELLES_FELT_DRIFTSMIDLER = {
    OBJEKTIDENTIFIKATOR: "objektidentifikator",
    OBJEKTBESKRIVELSE: "objektbeskrivelse",
    ERVERVSDATO: "ervervsdato"
};
var FELT = {
    SALDOAVSKREVET_ANLEGGSMIDDEL: {
        SALDOGRUPPE: "saldogruppe",
        OBJEKTIDENTIFIKATOR: FELLES_FELT_DRIFTSMIDLER.OBJEKTIDENTIFIKATOR,
        OBJEKTBESKRIVELSE: FELLES_FELT_DRIFTSMIDLER.OBJEKTBESKRIVELSE,
        ERVERVSDATO: FELLES_FELT_DRIFTSMIDLER.ERVERVSDATO,
        INNGAAENDE_VERDI: FELLES_FELT.INNGAAENDE_VERDI,
        UTGAAENDE_VERDI: FELLES_FELT.UTGAAENDE_VERDI
    },
    LINEAERT_AVSKREVET_ANLEGGSMIDDEL: {
        ANSKAFFELSESKOST: "anskaffelseskost",
        LEVETID: "levetid",
        OBJEKTIDENTIFIKATOR: FELLES_FELT_DRIFTSMIDLER.OBJEKTIDENTIFIKATOR,
        OBJEKTBESKRIVELSE: FELLES_FELT_DRIFTSMIDLER.OBJEKTBESKRIVELSE,
        ERVERVSDATO: FELLES_FELT_DRIFTSMIDLER.ERVERVSDATO,
        INNGAAENDE_VERDI: FELLES_FELT.INNGAAENDE_VERDI,
        UTGAAENDE_VERDI: FELLES_FELT.UTGAAENDE_VERDI
    },
    IKKE_AVSKRIVBARE_ANLEGGSMIDLER: {
        OBJEKTIDENTIFIKATOR: FELLES_FELT_DRIFTSMIDLER.OBJEKTIDENTIFIKATOR,
        OBJEKTBESKRIVELSE: FELLES_FELT_DRIFTSMIDLER.OBJEKTBESKRIVELSE,
        ERVERVSDATO: FELLES_FELT_DRIFTSMIDLER.ERVERVSDATO,
        INNGAAENDE_VERDI: FELLES_FELT.INNGAAENDE_VERDI,
        UTGAAENDE_VERDI: FELLES_FELT.UTGAAENDE_VERDI
    },
    GEVINST_OG_TAPSKONTO: {
        IDENTIFIKATOR: "gevinstOgTapskontoIdentifikator",
        INNGAAENDE_VERDI: FELLES_FELT.INNGAAENDE_VERDI,
        UTGAAENDE_VERDI: FELLES_FELT.UTGAAENDE_VERDI
    },
    TOEMMERKONTO: {
        INNGAAENDE_VERDI: "inngaaendeVerdiPaaToemmerkonto",
        UTGAAENDE_VERDI: "utgaaendeVerdiPaaToemmerkonto",
        INNGAAENDE_VERDI_TOEMMERAVVIRKNING: "inngaaendeVerdiAvToemmeravvirkning",
        UTGAAENDE_VERDI_TOEMMERAVVIRKNING: "utgaaendeVerdiAvToemmeravvirkning"
    },
    SKATTEMESSIG_RESULTAT: {
        ID: "sum.skattemessigResultat"
    },
    AARSRESULTAT: {
        ID: "aarsresultat"
    },
    SUM_TILLEGG_I_NAERINGSINNTEKT: {
        ID: "sum.sumTilleggINaeringsinntekt"
    },
    SUM_FRADRAG_I_NAERINGSINNTEKT: {
        ID: "sum.sumFradragINaeringsinntekt"
    },
    SUM_ENDRING_I_MIDLERTIDIG_FORSKJELL: {
        ID: "sum.sumEndringIMidlertidigForskjell"
    },
    FORDELT_SKATTEMESSIG_RESULTAT: {
        ID: "beregnetNaeringsinntekt.fordeltSkattemessigResultat"
    },
    NAERINGSTYPE: {
        ID: "beregnetNaeringsinntekt.naeringstype"
    },
    SJABLONGBEREGNET_INNTEKT_FRA_BIOMASSE_VEDPRODUKSJON: {
        ID: "beregnetNaeringsinntekt.sjablongberegnetInntektFraBiomasseVedproduksjon"
    },
    SJABLONGBEREGNET_FRADRAG_FRA_BIOMASSE_VEDPRODUKSJON: {
        ID: "beregnetNaeringsinntekt.sjablongberegnetFradragFraBiomasseVedproduksjon"
    },
    KORREKSJON_FRA_REINDRIFT: {
        ID: "beregnetNaeringsinntekt.korreksjonFraReindrift"
    },
    FRADRAG_FOR_RENTER_I_NAERING_PAA_SVALBARD: {
        ID: "beregnetNaeringsinntekt.fradragForRenterINaeringPaaSvalbard"
    },
    FREMFOERT_UNDERSKUDD_I_ENKELTPERSONFORETAK_PAA_SVALBARD_FRA_TIDLIGERE_AAR: {
        ID: "beregnetNaeringsinntekt.fremfoertUnderskuddIEnkeltpersonforetakPaaSvalbardFraTidligereAar"
    },
    FORDELT_SKATTEMESSIG_RESULTAT_ETTER_KORREKSJON: {
        ID: "beregnetNaeringsinntekt.fordeltSkattemessigResultatEtterKorreksjon"
    },
    ANDEL_AV_FORDELT_SKATTEMESSIG_RESULTAT_TILORDNET_INNEHAVER: {
        ID: "beregnetNaeringsinntekt.andelAvFordeltSkattemessigResultatTilordnetInnehaver"
    },
    FORDELT_SKATTEMESSIG_RESULTAT_ETTER_KORREKSJON_TILORDNET_INNEHAVER: {
        ID: "beregnetNaeringsinntekt.fordeltSkattemessigResultatEtterKorreksjonTilordnetInnehaver"
    },
    KASSASYSTEMTYPE: {
        ID: "kassasystem.kassasystemtype"
    },
    ANTALL_VARETYPER: {
        ID: "overnattingsOgServeringssted.antallVaretyper"
    },
    PRIVATE_UTTAK_ER_FOERT_PAA_PRIVATKONTO: {
        ID: "overnattingsOgServeringssted.privateUttakErFoertPaaPrivatkonto"
    },
    UTTAK_AV_VARER_TIL_PRIVAT_BRUK_ER_VERDSATT_TIL_OMSETNINGSVERDI: {
        ID: "overnattingsOgServeringssted.uttakAvVarerTilPrivatBrukErVerdsattTilOmsetningsverdi"
    },
    SAMLET_UTTAK_AV_VARER_TIL_PRIVAT_BRUK_FOERT_SOM_SALGSINNTEKT: {
        ID: "overnattingsOgServeringssted.samletUttakAvVarerTilPrivatBrukFoertSomSalgsinntekt"
    },
    UTTAK_AV_KOST_VARER_MV_TIL_REPRESENTASJON: {
        ID: "overnattingsOgServeringssted.uttakAvKostVarerMvTilRepresentasjon"
    },
    UTTAKSVERDI_ER_VERDSATT_TIL_OMSETNINGSVERDI: {
        ID: "overnattingsOgServeringssted.uttaksverdiErVerdsattTilOmsetningsverdi"
    },
    SAMLET_UTTAK_AV_KOST_VARER_MV_TIL_REPRESENTASJON: {
        ID: "overnattingsOgServeringssted.samletUttakAvKostVarerMvTilRepresentasjon"
    }
};
var _default = {
    KORTGRUPPER: KORTGRUPPER,
    KORT: KORT,
    DYNAMISK_GRUPPE: DYNAMISK_GRUPPE,
    FELT: FELT,
    LISTER: LISTER
};
